module.exports = __webpack_public_path__ + "img/four.ddba0f62.gif";